export default async({ store, route }) => {
  await store.dispatch('seo/getSEO', route)
}
